var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fields mb-4"},[_c('h4',[_vm._v(_vm._s(_vm.$t('Right')))]),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_right_oilTemperature',
          label: 'Oil temperature',
          disabled: false,
          description: 'Display oil temperature',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_right_brakesTemperature',
          label: 'Brakes temperature',
          disabled: false,
          description: 'Display brakes temperature',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_right_brakesAirPressure',
          label: 'Brakes air pressure',
          disabled: false,
          description: 'Display brakes air pressure',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_right_fuel',
          label: 'Fuel',
          disabled: false,
          description: 'Display the fuel level',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_right_fuelConsumption',
          label: 'Fuel consumption',
          disabled: false,
          description: 'Display the fuel average consumption',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_right_cruiseControl',
          label: 'Cruise control',
          disabled: false,
          description:
            'Display the current speed set with the cruise control ON',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_right_waterTemperature',
          label: 'Water temperature',
          disabled: false,
          description: 'Display the water temperature',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_right_batteryVoltage',
          label: 'Battery voltage',
          disabled: false,
          description: 'Display the battery voltage',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_right_restStop',
          label: 'Next rest stop',
          disabled: false,
          description: 'Display the time to go to the next rest stop',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_right_map',
          label: 'Display map',
          disabled: false,
          description: 'Enable or disable the map view',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false))],1),_c('div',{staticClass:"fields mb-4"},[_c('h4',[_vm._v(_vm._s(_vm.$t('Middle - Top')))]),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_mid_top_retarder',
          label: 'Retarder',
          disabled: false,
          description: 'Display the retarder indicator',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_mid_top_parkingBrake',
          label: 'Parking brake',
          disabled: false,
          description: 'Display the parking brake indicator',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_mid_top_beamHigh',
          label: 'Beam high',
          disabled: false,
          description: 'Display the high beam indicator',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_mid_top_beamLow',
          label: 'Beam low',
          disabled: false,
          description: 'Display the low beam indicator',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_mid_top_beacon',
          label: 'Beacon',
          disabled: false,
          description: 'Display the beacon indicator',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false))],1),_c('div',{staticClass:"fields mb-4"},[_c('h4',[_vm._v(_vm._s(_vm.$t('Middle - Bottom')))]),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_mid_bottom_rpm',
          label: 'RPM',
          disabled: false,
          description: 'Display the RPM',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_mid_bottom_fuel',
          label: 'Fuel',
          disabled: false,
          description: 'Display the fuel level indicator',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_mid_bottom_speedLimit',
          label: 'Speed limit',
          disabled: false,
          description: 'Display the speed limit',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
          id: 'jagfx_elements_mid_bottom_blinker_turn',
          label: 'Turning indicator',
          disabled: false,
          description:
            'Display an indicator when the turn left or turn right blinker are ON',
          values: _vm.fieldValues('on_off'),
          target: 'game'
        },false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }